// FOS-HOME-LAYER-FREEZE-001: what Rob did by hand on 2026-09-28 (force-close,
// open in Safari, re-add the icon) was clear the app's installed shell.
// The first Reload is a plain reload: the service worker now has time limits,
// and removing it on a still-bad connection would lose the cached app. Only a
// second stall soon after clears the worker and its caches, then reloads.
// Nothing here touches account data; the worker re-installs on the next load.
export const STALL_NOTICE_MS = 12000
export const STALL_RELOAD_KEY = 'fos_stall_reload_at'
export const STALL_RESET_WINDOW_MS = 5 * 60 * 1000

export const CLEANUP_STEP_MS = 3000

// A clean-up step that hangs must not block the reload.
const limit = (promise, ms) => Promise.race([promise, new Promise(resolve => setTimeout(resolve, ms))])

export async function clearAppShell(win = window, stepMs = CLEANUP_STEP_MS) {
  try {
    const registrations = await limit(win.navigator?.serviceWorker?.getRegistrations?.() || [], stepMs) || []
    await limit(Promise.all(registrations.map(registration => registration.unregister().catch(() => false))), stepMs)
  } catch { /* unregister is best effort */ }
  try {
    const names = await limit(win.caches?.keys?.() || [], stepMs) || []
    await limit(Promise.all(names.filter(name => name.startsWith('fragrance-os-')).map(name => win.caches.delete(name))), stepMs)
  } catch { /* cache storage can be unavailable */ }
}

export async function resetAppShell(win = window, now = Date.now()) {
  let recent = false
  try {
    const last = Number(win.sessionStorage?.getItem(STALL_RELOAD_KEY) || 0)
    recent = Boolean(last) && now - last < STALL_RESET_WINDOW_MS
    win.sessionStorage?.setItem(STALL_RELOAD_KEY, String(now))
  } catch { recent = true /* no storage: nothing to remember, so do the full reset */ }
  if (recent) await clearAppShell(win)
  win.location.reload()
}
